import AuthorizationLayout from './AuthorizationLayout';

export default AuthorizationLayout;
